// Command for removing list of seats from section
// Array should contain Objects with row, coll properties
const RemoveSeats = {
  order: Infinity,
  run($$) {
    $$.removeSeats = function (seats) {
      seats.forEach(function ({
        row,
        seat,
      }) {
        const seating = $$.getSeat(row, seat);
        if (!seating) {
          return;
        }
        seating.el.remove();
        delete $$.seats[`${row}-${seat}`];
      });
      $$.$.trigger("seat:rearrange", [Object.values($$.seats)]);
      return seats;
    };
  },
};

window.SectionRemoveSeats = RemoveSeats;

export default RemoveSeats;
